import "./WhatsAppButtonQuickMessage.css";

export default function WhatsAppButtonQuickMessage (props)
{
    return (
        <button className="whatsAppButtonQuickMessage" onClick={() => props.onClick(props.message)} title={props.message}>
            <span className="titleWhatsAppButtonQuickMessage">Título: {props.title}</span>
            <span className="messageWhatsAppButtonQuickMessage">Mensagem: {props.message}</span>
        </button>
    )
}